import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
export const MAPS_MERCHANTS = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'MAPS_MERCHANTS')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    if (_.isString(data.tags)) {
      // tags需要转化成数组
      data.tags = [data.tags]
    }
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/queryStoreList',
        requestAction: MAPS_MERCHANTS.INIT_REQUEST,
        successAction: MAPS_MERCHANTS.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MAPS_MERCHANTS.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [MAPS_MERCHANTS.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'mapsMerchants',
    reducerMap: {
      mapsMerchantsState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
